// arslan.io: post/page-only bundle (built/post.min.js), loaded with `defer` from
// partials/content.hbs. Everything here used to run on every page from main.min.js.

/* Add lightbox to gallery images */
lightbox('.kg-image-card > .kg-image[width][height], .kg-gallery-image > img');

/* Responsive video in post content */
reframe(
    document.querySelectorAll(
        [
            '.gh-content iframe[src*="youtube.com"]',
            '.gh-content iframe[src*="youtube-nocookie.com"]',
            '.gh-content iframe[src*="player.vimeo.com"]',
            '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
            '.gh-content object',
            '.gh-content embed',
        ].join(',')
    )
);

/* Table of contents: only when the content has a `.toc` container (HTML card) */
(function () {
    const content = document.querySelector('.single-content');
    const tocContainer = document.querySelector('.toc');
    if (!content || !tocContainer) return;

    // Merge custom config if provided via Code Injection
    const customConfig = window.tocbotConfig || {};
    const headingSelector = customConfig.headingSelector || 'h2, h3';
    if (!content.querySelector(headingSelector)) return;

    tocbot.init(
        Object.assign(
            {
                tocSelector: '.toc',
                contentSelector: '.single-content',
                headingSelector: 'h2, h3',
                hasInnerContainers: true,
                collapsibleClass: 'is-collapsible',
                scrollSmooth: false,
                scrollSmoothDuration: 300,
                scrollSmoothOffset: -150,
                headingsOffset: 150,
                ignoreSelector:
                    '.kg-card h2, .kg-card h3, .kg-card h4, .kg-card h5, .kg-card h6, .toc-sidebar h2, .toc-sidebar h3, .toc-sidebar h4, .toc-sidebar h5, .toc-sidebar h6',
            },
            customConfig
        )
    );
})();
